import moment from 'moment';
import { useRouter } from 'next/router';
import React, { createContext, useContext, useRef, useState } from 'react';
import { useTranslation } from '~i18n';

interface IDate {
  startDate: any;
  endDate: any;
}
export interface ISelectedBedProps {
  bedName: string | undefined | null;
  bedId: string | undefined | null;
  totalPriceOriginal: number | undefined | null;
  priceForBillingCycle: number | undefined | null;
  pricePerNight: number | undefined | null;
  pricePerNightOriginal: number | undefined | null;
  marketingPrice?: number | undefined | null;
  marketingInstallmentNumber?: number | undefined | null;
  pricePerMonth: number | undefined | null;
  pricePerMonthOriginal: number | undefined | null;
}

export const initialSelectedFlat = {
  bedName: '',
  bedId: '',
  totalPriceOriginal: 0,
  priceForBillingCycle: 0,
  pricePerNight: 0,
  pricePerNightOriginal: 0,
  marketingPrice: 0,
  marketingInstallmentNumber: 0,
  pricePerMonth: 0,
  pricePerMonthOriginal: 0,
};

export const defaultEditBookingInput = {
  academicYearId: '',
  tenancyOptionId: '',
  tenancyStartDate: '',
  tenancyEndDate: '',
  roomTypeId: '',
};

interface IBookingProcessSelectBedProps {
  selectedFlat: ISelectedBedProps;
  setSelectedFlat: (value: ISelectedBedProps) => void;

  selectBedRoomTypeId: string;
  setSelectBedRoomTypeId: (id: string) => void;

  selectBedTenancyOptionId: string | null;
  setSelectBedTenancyOptionId: (id: string) => void;

  selectBedAcademicYearId: string;
  setSelectBedAcademicYearId: (id: string) => void;

  selectBedTenancyDate: IDate;
  setSelectBedTenancyDate: (date: IDate) => void;

  initEditBookingInput: any;
}

const BookingProcessSelectBedContext = createContext<IBookingProcessSelectBedProps>({
  selectedFlat: initialSelectedFlat,
  setSelectedFlat: () => {},

  selectBedRoomTypeId: '',
  setSelectBedRoomTypeId: () => {},

  selectBedTenancyOptionId: '',
  setSelectBedTenancyOptionId: () => {},

  selectBedAcademicYearId: '',
  setSelectBedAcademicYearId: () => {},

  selectBedTenancyDate: {
    startDate: '',
    endDate: '',
  },
  setSelectBedTenancyDate: () => {},

  initEditBookingInput: {},
});

export const BookingProcessSelectBedProvider: React.FC = ({ children }) => {
  const { t } = useTranslation(['student_portal']);
  const router = useRouter();

  const {
    initialRoomTypeId,
    initialTenancyOptionId,
    initialAcademicYearId,
    initialTenancyEndDate,
    initialTenancyStartDate,
  } = router.query;

  const initEditBookingInput = useRef({
    ...defaultEditBookingInput,
  });

  const [selectedFlat, setSelectedFlat] = useState<ISelectedBedProps>(initialSelectedFlat);

  const [selectBedRoomTypeId, setSelectBedRoomTypeId] = useState(
    initialRoomTypeId ? initialRoomTypeId.toString() : ''
  );

  const [selectBedTenancyOptionId, setSelectBedTenancyOptionId] = useState(
    initialTenancyOptionId ? initialTenancyOptionId.toString() : null
  );
  const [selectBedAcademicYearId, setSelectBedAcademicYearId] = useState(
    initialAcademicYearId ? initialAcademicYearId.toString() : ''
  );

  const [selectBedTenancyDate, setSelectBedTenancyDate] = useState<IDate>({
    startDate: initialTenancyStartDate ? moment(initialTenancyStartDate) : '',
    endDate: initialTenancyEndDate ? moment(initialTenancyEndDate) : '',
  });

  return (
    <BookingProcessSelectBedContext.Provider
      value={{
        selectedFlat,
        setSelectedFlat,

        selectBedRoomTypeId,
        setSelectBedRoomTypeId,

        selectBedTenancyOptionId,
        setSelectBedTenancyOptionId,

        selectBedAcademicYearId,
        setSelectBedAcademicYearId,

        selectBedTenancyDate,
        setSelectBedTenancyDate,

        initEditBookingInput,
      }}
    >
      {children}
    </BookingProcessSelectBedContext.Provider>
  );
};

export const useBookingProcessSelectBedContenxt = () => useContext(BookingProcessSelectBedContext);
